// Версия совпадает с cap-widget в package.json shared-ui: web берёт виджет из бандла, native — из CDN.
const CAP_WIDGET_URL = 'https://cdn.jsdelivr.net/npm/cap-widget@0.1.58/cap.min.js'

export const CAPTCHA_SOLVE_TIMEOUT_MS = 30_000

// Эндпоинт Cap (инстанс + ключ сайта) публичный и одинаковый для всех окружений — в env не выносим.
export const CAPTCHA_ENDPOINT = 'https://cap.yakarta.io/4d3da83dcb/'

// URL.origin в React Native не реализован — достаём origin регуляркой.
export const CAPTCHA_ORIGIN = /^https?:\/\/[^/]+/i.exec(CAPTCHA_ENDPOINT)?.[0]

type CaptchaMessage = { type: 'solve'; token: string } | { type: 'error' }

export const buildCaptchaHtml = (): string => `<!DOCTYPE html>
<html>
<head><meta charset="utf-8" /><meta name="viewport" content="width=device-width, initial-scale=1" /></head>
<body>
<script>
  window.CAP_SILENT = true;
  function capPost(message) { window.ReactNativeWebView.postMessage(JSON.stringify(message)); }
  function capFail() { capPost({ type: 'error' }); }
  function capSolve() {
    new window.Cap({ apiEndpoint: ${JSON.stringify(CAPTCHA_ENDPOINT)} })
      .solve()
      .then(function (result) {
        if (result && result.success && result.token) capPost({ type: 'solve', token: result.token });
        else capFail();
      })
      .catch(capFail);
  }
</script>
<script src="${CAP_WIDGET_URL}" onload="capSolve()" onerror="capFail()"></script>
</body>
</html>`

export const parseCaptchaMessage = (data: string): CaptchaMessage | null => {
  try {
    const message: unknown = JSON.parse(data)

    if (typeof message !== 'object' || message === null || !('type' in message)) return null

    if (message.type === 'solve' && 'token' in message && typeof message.token === 'string' && message.token) {
      return { type: 'solve', token: message.token }
    }

    return message.type === 'error' ? { type: 'error' } : null
  } catch {
    return null
  }
}
